<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <!-- Bouton de rafraîchissement -->
        <b-row class="justify-content-start">
          <b-col cols="4" lg="2" xl="1" class="mb-5">
            <b-button class="btn btnFilter" :disabled="activateSpinner" @click="onRefresh">
              <i class="fa-light fa-rotate-right fs-14px"></i>
            {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
        </b-row>

        <b-row class="justify-content-center mb-5">
          <div>
            <spinner v-if="activateSpinner"></spinner>
            <b-table v-else-if="listItems.length > 0"
              fixed hover
              :items="listItems"
              :fields="fields"
              :sort-by.sync="sortBy"
              class="table-striped"
              :selectable="listItems.length > 0"
              :empty-text="$t('common.security.no_result')"
              @row-selected="seeMQSeriesDetails"
              :key="refreshKey">
              <template #cell(Name)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(Host)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(Port)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(SSLActive)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(ConnectionMode)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(ConnectionType)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(QueueManager)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(ChannelName)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(QueueName)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(edit)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.value)">
                  <i class="fa-regular fa-pencil"></i>
                </span>
              </template>
              <template #cell(delete)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.value)">
                  <i class="fa-regular fa-trash"></i>
                </span>
              </template>
            </b-table>
            <div v-else class="d-flex justify-content-center">
              <span class="noResult">
                {{ $t('common.no_result') }}
              </span>
            </div>
          </div>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'
import { errorMessageAlert } from '@/helpers/alert'
import { loadPage } from '@/helpers/routing'

// A NOTER
// Cette page ne semble être appelée que par elle même...

export default {
  name: 'MQSeriesConfigurationPage',
  components: {
  'form-write-group-label-input':formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    id: {
      type: String,
      default: '-1'
    }
  },
  data () {
    return {
      activateSpinner: false,
      listTitle: '',
      refreshKey: false,
      listItems: [],
      elementSearchedMQSeriesConfig: '',
      sortBy: 'Name'
    }
  },
  computed: {
    canAdd () {
      return true
    },
    canEdit () {
      return true
    },
    canDelete () {
      return true
    },
    fields () {
      let fields = []

      fields.push({
        key: 'Name',
        label: this.$t('common.routing.config_name'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'Host',
        label: this.$t('common.routing.host'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'Port',
        label: this.$t('common.routing.port'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'SSLActive',
        label: this.$t('common.routing.ssl_active'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'ConnectionMode',
        label: this.$t('common.routing.connection_mode'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'ConnectionType',
        label: this.$t('common.routing.connection_type'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'QueueManager',
        label: this.$t('common.routing.queue_manager'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'ChannelName',
        label: this.$t('common.routing.channel_name'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'QueueName',
        label: this.$t('common.routing.queue_name'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      // if (this.canEdit) {
      //   fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      // }
      return fields
    }
  },
  created () {
    this.listTitle = this.$i18n.t('Webheader.mqseriesConfig_consult')
    this.activateSpinner = true
    this.getMQSeriesConfig()

    if (this.id !== '-1') {
      this.tabName = parseInt(this.id)
    }
  },
  methods: {
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$t('common.security.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = { id: id }
              that.$engine.routing.config.mqseries.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.security.mqseries_config_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, { url: '/routing/mqseriesConfig/-1' })
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.security.cert_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () { return }
          }
        ]
      })
    },
    // actionEdit ($e, id) {
    //   loadPage(this, { url: '/routing/interProcessConfig/edit/' + id })
    // },
    applyFilters (typeList) {
      this.activateSpinner = true
      this.getMQSeriesConfig()
    },
    emptyFilters (typeList) {
      this.activateSpinner = true
      this.getMQSeriesConfig()
    },
    getMQSeriesConfig () {
      let params = { name: this.elementSearchedMQSeriesConfig }
      let that = this
      this.$engine.routing.config.mqseries.fetch(params)
      .then(resp => {
        let mqSeriesConfigList = {}

        mqSeriesConfigList = resp.data.MQSeries
        for (let i = 0; i < mqSeriesConfigList.length; i++) {
          mqSeriesConfigList[i].delete = mqSeriesConfigList[i].id
          mqSeriesConfigList[i].edit = mqSeriesConfigList[i].id
        }
        that.updateMQSeriesConfig(mqSeriesConfigList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onRefresh () {
      this.refreshKey = !this.refreshKey;
      this.activateSpinner = true;
      this.getMQSeriesConfig();
    },
    seeMQSeriesDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/mqseriesConfigurationDetails/details'})
    },
    updateMQSeriesConfig (mqseriesList) {
      let that = this
      this.listItems = mqseriesList
      this.listItems.forEach(mqseries=> {
        if(mqseries.SSL === '1') {
          mqseries.SSLActive = that.$t('common.routing.yes')
        } else {
          mqseries.SSLActive = that.$t('common.routing.no')
        }
      })
    },
  }
}
</script>
